// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import StationQueue from './StationQueue'

/**
 * Production queue — Rxs cleared for fulfillment work.
 *
 * Bundles two clinical states:
 *  - `verified`        Pharmacist has signed off; ready for fill
 *  - `ready_to_fill`   Insurance cleared; ready to compound/dispense
 *
 * Per PM-2 + U-04: pharmacy techs treat these as one queue. The
 * verification action happens upstream (Intake), so once an Rx hits
 * verified or ready_to_fill it's "in production."
 */
export default function ProductionTab() {
  return (
    <StationQueue
      states="verified,ready_to_fill"
      tabKey="production"
      title="Production"
      subtitle="Verified prescriptions and those cleared by insurance, ready to fill."
      emptyMessage="No prescriptions in production."
    />
  )
}
